import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, inject, InjectFlags, Input, OnInit } from '@angular/core';
import { FILETYPES } from '@digilize/shared/definitions/src/lib/constants/fileTypes';
import { fileTypes } from '@digilize/shared/definitions/src/lib/interfaces/fileTypes';
import { AuthService } from '@digilize/shared/feature/modules/auth/src';
import { AnimationOptions } from 'ngx-lottie';
import { catchError, throwError } from 'rxjs';

import { CvService } from '../../../services/cv.service';
import { WizardService } from '../../../services/wizard.service';
import { CvSkillsComponent } from '../cv-skills/cv-skills.component';

@Component({
  selector: 'bwc-uploaded-cv',
  templateUrl: './uploaded-cv.component.html',
  styleUrls: ['./uploaded-cv.component.scss'],
  animations: [trigger('fadeInOut', [state('void', style({ opacity: 0 })), transition('void <=> *', animate(300))])],
})
export class UploadedCvComponent implements OnInit {
  @Input() openFormLink: string;
  @Input() inviteLink: string;
  @Input() vacancyId: string;
  @Input() source: string;
  @Input() prevBut: boolean;
  @Input() closeBut: boolean;

  wizardService = inject(WizardService, InjectFlags.Optional);

  fileTypes: fileTypes[] = FILETYPES;
  uploadedFile: File;
  mockFileName: string | null = null;
  uploadError: boolean;
  loading = false;
  options: AnimationOptions = {
    path: './assets/animations/animation-checking.json',
    loop: true,
  };

  constructor(private cvService: CvService, private authService: AuthService) {}

  ngOnInit(): void {
    this.uploadedFile = this.wizardService?.uploadedFile;
    this.uploadError = this.wizardService?.uploadError ?? false;
    if (!this.uploadedFile) {
      this.mockFileName = this.wizardService?.uploadedFileName;
    }
  }

  removeFile() {
    if (this.wizardService) {
      this.wizardService.uploadedFileName = null;
    }
    this.mockFileName = null;
    this.wizardService?.goToPrevious();
  }

  startCheckingCV() {
    if (!this.uploadedFile) {
      this.wizardService?.goToNext();
      return;
    }
    this.loading = true;
    const formData = new FormData();
    formData.append('file', this.uploadedFile);
    if (this.openFormLink) {
      formData.append('OpenLinkId', this.openFormLink);
    }
    if (this.inviteLink) {
      formData.append('InvitationId', this.inviteLink);
    }
    if (this.vacancyId) {
      formData.append('VacancyId', this.vacancyId);
    }

    this.cvService
      .uploadCV(formData, this.source)
      .pipe(
        catchError((err) => {
          this.loading = false;
          this.uploadError = true;
          console.error('CV upload failed:', err);
          return throwError(err);
        })
      )
      .subscribe((resp: any) => {
        this.authService.setSession({
          token: resp.anonymous_user_token,
          refresh_token: resp.anonymous_user_refresh_token,
        });

        this.cvService.getCV().subscribe(
          (cv) => {
            const skillIds = [
              ...(cv.skills ?? []),
              ...(cv.soft_skills ?? []),
              ...(cv.knowledge_skills ?? []),
            ]
              .map((s) => s.id)
              .filter(Boolean);
            CvSkillsComponent.saveParsedSkillIds(skillIds);
            this.loading = false;
            this.wizardService?.goToNext();
          },
          () => {
            this.loading = false;
            this.wizardService?.goToNext();
          }
        );
      });
  }

  goPrev() {
    this.wizardService?.goToPrevious();
  }

  tryAgain() {
    this.wizardService?.goToPrevious();
  }
}
